import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { catchError, of, Subject, takeUntil } from 'rxjs';
import { SwiperConfig } from 'src/app/config/swiper.config';
import { OrderModel } from 'src/app/models/order.model';
import { AlertService } from 'src/app/services/alert.service';
import { OrderService } from 'src/app/services/order.service';
import { MyProfileService } from 'src/app/services/my-profile.service';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import Swiper from 'swiper';
import { CustomerDataRequirementTypeEnum } from '../../pages/event/event.component';
import { AuthService } from 'src/app/services/auth.service';
import { FormHelper } from '../../../helpers/form.helper';
import { testPhones, validaCPF } from 'src/app/helpers/utils.helper';

@Component({
  selector: 'app-ticket-holders',
  templateUrl: './ticket-holders.component.html',
  styleUrls: ['./ticket-holders.component.scss']
})
export class TicketHoldersComponent implements OnInit, OnDestroy {

  @Input()
  public customerDataRequirementType: CustomerDataRequirementTypeEnum = CustomerDataRequirementTypeEnum.NotRequired;

  public loadingFindUser: boolean = false;

  public order!: OrderModel;
  public sesiTerms: string = "O comprador concorda que o evento poderá ser, por parte da IngressoSA ou do Sistema Indústria (CNI, SESI, SENAI e IEL), filmado, gravado e/ou fotografado para posterior publicação, transmissão, retransmissão, reprodução e/ou divulgação em televisão, cinema, rádio, internet, redes sociais, publicidade em geral e qualquer outro veículo de comunicação, produção de CD e DVD. O Comprador concorda que, ao comparecer ao evento/espetáculo, autoriza a utilização gratuita de sua imagem, nome e voz, nos termos ora mencionados, no Brasil e no exterior, sem limite de vezes e tempo, sem que isso caracterize uso indevido da imagem ou qualquer outro direito e sem que dessa utilização ocorra qualquer ônus e/ou indenização."
  public showSesiTerms: boolean = false
  public sesiEvents = [
    "b2c13214-217e-4ae4-91f1-97fdf73b9cd2",
    "bfb2fe3a-e0f9-4fab-bc1e-d1520ee6e9c8",
    "93da81ab-8069-49cc-b5ce-821a9c8cb019",
    "92fe33ac-f50a-463b-be4a-62bdd78ea055",
    "327742cf-2f73-488d-908a-bcbd7c440286",
    "0763f8e9-73fc-4ef1-98fc-54ea72e8c26b",
    "c0011a5d-8730-43f1-a5c8-e655260ed681",
    "de4d9eb5-da49-4ef9-a9fa-934fed924e40",
    "b55c3a53-96be-4e48-9592-d4d2d8f2b9be",
    "5a335743-3767-43e9-a038-1da639ec3e91",
    "d070af08-6c11-4ed0-8f83-d8977b84bf02",
    "45df1529-74d8-46a6-9957-312950e18beb",
    "cbe3128e-203d-44d2-a318-543c57bc8016",
    "921c8643-3161-4d26-b6eb-4187083ff279",
    "07df87d1-63fc-4888-80ee-2506a329caa6",
    "cfe1d9c8-1c0c-4111-94ce-f2062dca874b",
    "470464a1-6314-4f82-a535-b00215904566",
    "d0cb1828-e2a2-43f6-87f1-55436de5906a",
    "b1bd3ea2-45fc-416e-b7a3-7759a323bdbd",
    "a1e1cd02-f972-4469-98aa-89c6381e9a8d",
    "6ddb97be-0c87-4b97-8609-3880541a3d5b",
    "3797fe20-f53a-4fde-88d1-a3b6abb12dba",
    "fb55a102-84ad-421d-ab5e-e747b5d15d95",
    "ac74fc0f-dbd6-4cd2-9891-1147a185cef6",
    "635138ce-385a-4150-af9c-a965c08ecb04",
    "7f042ac9-d77c-484f-b61f-c5d66832477d",
    "952fddb0-5c87-4140-bdf3-3643fb7ab67e"
  ]
  public swiper!: Swiper;
  public config = SwiperConfig.ticketHolders;
  public onComplete = new Subject<any>();
  private unsubscribe$ = new Subject();
  public customers!: FormGroup
  public idx = 0
  public sesiTermsOfUseAccepted: boolean = false

  constructor(
    private bsModalRef: BsModalRef,
    private myProfileService: MyProfileService,
    public fb: FormBuilder,
    private orderService: OrderService,
    private alertService: AlertService,
    private authService: AuthService,
    private formHelper: FormHelper
  ) { }

  ngOnInit(): void {
    this.customers = this.fb.group({
      'customer': this.fb.array([])
    })
    this.loadOrder();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  public onSwiper(swiper: Swiper): void {
    this.swiper = swiper;
  }

  public clearForm(id) {
    (document!.getElementById("name" + id)! as HTMLInputElement).value = "";
    (document!.getElementById("email" + id)! as HTMLInputElement).value = "";
    (document!.getElementById("phone" + id)! as HTMLInputElement).value = "";
  }

  public enableForm(id) {
    (document!.getElementById("name" + id)! as HTMLInputElement).disabled = false;
    (document!.getElementById("email" + id)! as HTMLInputElement).disabled = false;
    (document!.getElementById("phone" + id)! as HTMLInputElement).disabled = false;
    (this.customers.get('customer') as FormArray).at(this.idx).get("name")?.enable();
    (this.customers.get('customer') as FormArray).at(this.idx).get("email")?.enable();
    (this.customers.get('customer') as FormArray).at(this.idx).get("phone")?.enable();
  }

  public findUser(id) {
    if ((this.customers.get('customer') as FormArray).at(this.idx).get("doc")!.value.length == 14) {
      this.loadingFindUser = true;
      this.myProfileService.checkCustomerRegisterWithCpf((this.customers.get('customer') as FormArray).at(this.idx).get("doc")!.value).subscribe((re) => {
        this.loadingFindUser = false;

        if (!re || re.length == 0) {
          if (this.order.tickets[this.idx].useFacialRecognition) {
            this.alertService.toast({
              icon: 'error',
              title: 'Não foi possível encontrar um usuário com este CPF. Por favor, informe um CPF cadastrado.'
            });
            return;
          }

          if (this.customerDataRequirementType == CustomerDataRequirementTypeEnum.Obrigatory) {
            this.alertService.toast({
              icon: 'error',
              title: 'Não foi possível encontrar um usuário com este CPF. Por favor, informe os dados do titular do ingresso.'
            });
            this.clearForm(id);
            this.enableForm(id);
            return;
          }

          if (this.customerDataRequirementType == CustomerDataRequirementTypeEnum.Optional) {
            this.alertService.toast({
              icon: 'warning',
              title: 'Não foi possível encontrar um usuário com este CPF. Preencha as informações do titular do ingresso.'
            });
            this.clearForm(id);
            this.enableForm(id);
            return;
          }
        }

        if (this.order.tickets[this.idx].useFacialRecognition) {
          if (!re[0].hasImage) {
            this.alertService.toast({
              icon: 'error',
              title: `É necessário informar um usuário com imagem de reconhecimento facial. Por favor, solicite o titular do CPF ${re[0]?.doc || ''} o cadastro da imagem antes de continuar.`
            });
            this.clearForm(id);
            return;
          }
        }

        const phone = re[0].phones?.length > 0 ? re[0].phones[0].replace(/\s+/g, "") : null;

        (document!.getElementById("name" + id)! as HTMLInputElement).disabled = true;
        (document!.getElementById("email" + id)! as HTMLInputElement).disabled = true;
        (document!.getElementById("phone" + id)! as HTMLInputElement).disabled = phone == null ? false : true;

        (this.customers.get('customer') as FormArray).at(this.idx).get("name")!.setValue(re[0].name);
        (this.customers.get('customer') as FormArray).at(this.idx).get("email")!.setValue(re[0].email);
        (this.customers.get('customer') as FormArray).at(this.idx).get("phone")!.setValue(phone);

      },
        catchError(() => {
          this.loadingFindUser = false;
          return of(null);
        })
      )
    }
  }

  public preventTab(event: KeyboardEvent): void {
    if (event.key === 'Tab') {
      event.preventDefault();
      const enterEvent = new KeyboardEvent('keydown', { key: 'Enter' });
      event.target?.dispatchEvent(enterEvent);
    }
  }

  public back() {
    if (this.swiper.activeIndex == 0) {
      this.onComplete.next(false);
      this.bsModalRef.hide();
    } else {
      this.swiper.slidePrev();
      this.idx = this.swiper.activeIndex
    }
  }

  public continue() {
    this.idx = this.swiper.activeIndex;
    const customers = (this.customers.get('customer') as FormArray);
    const currentCustomer = customers.at(this.idx);
    

    let allowedDuplicateCount = this.order.event?.limitByCPF ? this.order.event?.limitByCPF : 0;
    if (this.order.tickets[this.idx].useFacialRecognition) {
      allowedDuplicateCount = 1;
    }

    if (currentCustomer.get("phone")?.value && !testPhones([currentCustomer.get("phone")?.value])) {
      this.alertService.toast({
        icon: 'error',
        title: 'Verfique se o telefone informado no ingresso é válido'
      });
      return;
    }

    if (currentCustomer.get("doc")?.value && !validaCPF(currentCustomer.get("doc")?.value)) {
      this.alertService.toast({
        icon: 'error',
        title: 'Verfique se o CPF informado no ingresso é válido'
      });
      return;
    }

    const hasAnyValue = currentCustomer.get("name")?.value ||
      currentCustomer.get("doc")?.value ||
      currentCustomer.get("email")?.value ||
      currentCustomer.get("phone")?.value;

    const hasAllValues = currentCustomer.get("name")?.value &&
      currentCustomer.get("doc")?.value &&
      currentCustomer.get("email")?.value &&
      currentCustomer.get("phone")?.value;

    if (hasAnyValue && !hasAllValues) {
      this.alertService.toast({
        icon: 'error',
        title: 'Se algum campo for preenchido, todos os campos devem ser preenchidos!'
      });
      return;
    }

    if (
      this.customerDataRequirementType == CustomerDataRequirementTypeEnum.Obrigatory && !hasAllValues
    ) {
      this.alertService.toast({
        icon: 'error',
        title: 'Todos os campos são obrigatórios para esse ingresso!'
      });
      return;
    }

    const duplicateCount = this.order.tickets.filter((ticket, index) => ticket.customer?.doc != null && ticket.customer?.doc == currentCustomer.get("doc")!.value && index != this.idx).length;
    if (allowedDuplicateCount != 0 && duplicateCount >= allowedDuplicateCount) {
      const foundIndex = this.order.tickets.findIndex((ticket, index) => ticket.customer?.doc == currentCustomer.get("doc")!.value && index != this.idx);
      this.alertService.toast({
        icon: 'error',
        title: `O CPF ${currentCustomer.get("doc")!.value} já está informado no ingresso ${foundIndex + 1}.`
      });
      this.clearForm(this.idx);
      return;
    }

    if (this.showSesiTerms == true && this.order.tickets[this.idx].sesiTermsAccepted == false) {
      this.alertService.toast({
        icon: 'error',
        title: 'Você precisa aceitar os termos do ingresso'
      });
      return
    }


    this.order.tickets[this.idx].customer = {
      doc: currentCustomer.get("doc")!.value,
      name: currentCustomer.get("name")!.value,
      email: currentCustomer.get("email")!.value,
      phones: currentCustomer.get("phone")?.value ? [currentCustomer.get("phone")!.value] : undefined
    };

    this.orderService.saveHolder(this.order.tickets[this.idx].customer, this.idx);

    const remainingTickets = this.order.tickets.slice(this.idx + 1);
    const hasUnfilledTickets = remainingTickets.some(ticket => !ticket.customer);

    if (hasUnfilledTickets) {
      this.swiper.slideNext();
      this.idx = this.swiper.activeIndex;
    } else {
      this.onComplete.next(true);
      this.bsModalRef.hide();
    }
  }

  sesiTermsOfUseChange(eve: any) {
    (this.order.tickets[this.swiper.activeIndex] as any).sesiTermsAccepted = eve.srcElement.checked 
  }

  private loadOrder() {
    this.orderService.currentOrder
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(order => {
        this.order = order;

      

        if (this.sesiEvents.indexOf(this?.order?.event?.id as string) > -1) {
          let tickets: any  = []
          this.order.tickets.forEach((res) => {
              (res as any).sesiTermsAccepted = false
              tickets[tickets.length] = res
          })
          this.showSesiTerms = true
        }

    

        this.order.tickets.forEach(element => {
          let customer = this.fb.group({
            doc: { value: element.customer?.doc, disabled: false },
            name: { value: element.customer?.name, disabled: true },
            email: [{ value: element.customer?.email, disabled: true }, [Validators.email]],
            phone: [{ value: element.customer?.phones?.length ? element.customer.phones[0] : '', disabled: false }],
          });

          (this.customers.get('customer') as FormArray).push(customer);
        });

        if (!this.order.tickets[0].customer?.doc) {
          const customer = this.authService.getCustomer();
          if (!customer) {
            return;
          }

          let phone = '';
          if (customer.phones?.length) {
            phone = customer.phones[0];
          }

          this.order.tickets[0].customer = {
            doc: customer.doc,
            name: customer.name,
            email: customer.email,
            phones: [phone]
          };

          const firstFormCustomer = (this.customers.get('customer') as FormArray).at(0);

          firstFormCustomer.get("doc")!.setValue(customer.doc)
          firstFormCustomer.get("name")!.setValue(customer.name)
          firstFormCustomer.get("email")!.setValue(customer.email)

          firstFormCustomer.get("phone")!.setValue(phone)
          firstFormCustomer.get("phone")!.enable();

        }

      });
  }
}
